import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home, Zap, Sun, Users } from 'lucide-react';
import { Button } from '../ui/button';

const MissionSection = () => {
  const highlights = [
    { icon: Home, text: "Full Home Electrification" },
    { icon: Sun, text: "Clean Solar Energy" },
    { icon: Zap, text: "Smart Battery Storage" },
    { icon: Users, text: "10+ Years Helping Aussies" }
  ];

  return (
    <section className="py-16 md:py-20 bg-[#3D5A47]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Side - Headline */}
          <div>
            <span className="text-[#B5D43B] font-semibold text-sm tracking-wider uppercase mb-4 block">
              Our Mission
            </span>
            <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight">
              Making Sustainable Living a Reality
            </h2>
          </div>

          {/* Right Side - Blurb */}
          <div>
            <p className="text-white/90 text-lg leading-relaxed mb-6">
              At Supa Energy Hub, we're committed to transforming Australian homes into energy-efficient powerhouses. 
              For over a decade, we've been helping Aussie families embrace <strong className="text-[#B5D43B]">full home electrification</strong> — 
              replacing gas and grid dependency with clean, renewable energy solutions.
            </p>
            <p className="text-white/80 leading-relaxed mb-8">
              From solar panels to batteries, heat pumps to EV chargers, we provide everything you need to power 
              your home sustainably while saving money. Our mission is simple: make clean energy accessible, 
              affordable, and hassle-free for every Australian household.
            </p>

            {/* Highlights */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-[#B5D43B]/20 flex items-center justify-center">
                    <item.icon className="w-5 h-5 text-[#B5D43B]" />
                  </div>
                  <span className="text-white/90 text-sm font-medium">{item.text}</span>
                </div>
              ))}
            </div>

            <Link to="/about">
              <Button className="bg-[#B5D43B] hover:bg-[#a3c235] text-[#3D5A47] font-semibold gap-2">
                Learn More About Us
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
